import React, { useEffect, useState } from "react";
import * as FaIcons from "react-icons/fa";
import { useParams, Link, useNavigate } from "react-router-dom";
import Popup from "reactjs-popup";
import { getTab } from "../../Routes/Analysis.js";
import { tabInfo } from "../../Routes/Analysis.js";
import Clarification from "./Clarification.js";
import 'reactjs-popup/dist/index.css';

import { tcRatingToLetter, userLetterToRating, userRatingToLetter, compLetterToRating, compRatingToLetter } from "../MyDocuments/RatingConverter.js";
import { useDispatch, useSelector } from "react-redux";
import axios from 'axios';

import {
    TC_URATE_UPDATED,
    TC_CRATE_UPDATED,
    TC_UTC_UPDATED,
    TC_UPDATED,
    TC_INVALIDATED,
    TC_UNSAVED_DELETE,
    TC_UCRATE_UPDATED,
} from "../../Constants/tcConstants.js";

import {
    C_ID_UPDATED,
    C_INVALIDATED,    
} from "../../Constants/cConstants.js"

const grades = [
    {grade: "A", desc: "Safe"},
    {grade: "B", desc: "Relatively Safe"},
    {grade: "C", desc: "Neither Safe Nor Unsafe"},
    {grade: "D", desc: "Unsafe"},
    {grade: "F", desc: "Very Unsafe"}
]

const DocumentSide = () => {
    const navigate = useNavigate();

    const dispatch = useDispatch();

    const { isAuth } = useSelector((state) => state.user);

    const { tc, gtc, comp, analysis, ucomp, unsaveds } = useSelector((state) => state.tc);

    const params = useParams();


    const [docName, setDocName] = useState("No Name Specified");
    // const [contractType, setContractType] = useState(localStorage.getItem("newContractType"));
    // const [product, setProduct] = useState(localStorage.getItem("newProduct"));
    // const [company, setCompany] = useState(localStorage.getItem("newCompany"));
    const [contractType, setContractType] = useState("No Contract Specified");
    const [product, setProduct] = useState("No Product Specified");
    const [company, setCompany] = useState("No Company Specified");
    const [companyRating, setCompanyRating] = useState(" ");
    const [documentRating, setDocumentRating] = useState(" ");
    const [userRating, setUserRating] = useState(" ");
    const [content, setContent] = useState("default");
    const [gradeDoc, setGradeDoc] = useState(null);
    const [gradeComp, setGradeComp] = useState(null);
    const [isOpenSave, setIsOpenSave] = useState(false);
    const [isOpenDoc, setIsOpenDoc] = useState(false);
    const [isOpenComp, setIsOpenComp] = useState(false);
    const [isOpenDelete, setIsOpenDelete] = useState(false);
    const [isOpenKey, setIsOpenKey] = useState(false);

    const [isSaved, setIsSaved] = useState(true);

    let [popupName, popupType, popupProduct, popupCompany] = [docName, contractType, product, company];
    const [active, setActive] = useState(false);

    //don't get rid of this, Clarification.js uses these.
    // eslint-disable-next-line
    const [clarificationText, setClarificationText] = useState("");
    // eslint-disable-next-line
    const [clarificationContent, setClarificationContent] = useState(null);
    // eslint-disable-next-line
    const [displayClarificationPopup, setDisplayClarificationPopup] = useState(false);
    
    const [isSigned, setIsSigned] = useState(false);
    const [isExpirySet, setIsExpirySet] = useState(false);

    const today = new Date();
    const year = today.getFullYear();
    const month = (today.getMonth()+1) <= 9 ? "0"+(today.getMonth()+1) : today.getMonth()+1;
    const day = today.getDate() <= 9 ? "0"+today.getDate() : today.getDate();
    const [date, setDate] = useState(year + "-" + month + "-" + day);

    const [expDate, setExpDate] = useState("");

    // localStorageReset();

    useEffect(() => {
        setIsSaved(!(unsaveds.hasOwnProperty(params.tcid)));
    }, [ unsaveds, params.tcid ]);

    //COMPARISON STUFF START
    //sets comparison document (right side) to nearest version of the left document.
    const setRightDocToNearestVersion = () => {
        if (isSaved && gtc !== null){
            axios({
                method: 'get',
                url: `api/v1/tcs/versions/${gtc._id}`,
                baseURL:'/',
            })
            .then((response) => {
                if (response.data.success){
                const docId = findNearestVerId(response.data.versions);
                if (docId !== null) {
                    dispatch({ type: C_ID_UPDATED, payload: { c_id: docId } });
                } else {
                    dispatch({ type: C_INVALIDATED });
                }
                } else {
                throw Error("Failed to retrieve all versions of contract");
                }
            })
            .catch((error) => {
                alert("Failed to retrieve all versions of your contract");
                dispatch({ type: C_INVALIDATED });
            });
        } else {
            dispatch({ type: C_INVALIDATED });
        }
    };

    //returns null if no other versions of contract exist.
    const findNearestVerId = (versions) => {
        if (versions.length >= 2){
        let doc_id;
        if (versions[0]._id === tc._id){
            doc_id = versions[1]._id;
        } else {
            doc_id = versions[0]._id;
        }
        return doc_id;
        } else {
        return null;
        }
    }

    // useEffect(() => {
    //   setIsSaved(!(unsaveds.hasOwnProperty(params.tcid)));
    // }, [unsaveds]);

    useEffect(() => {

        setRightDocToNearestVersion();
    // eslint-disable-next-line
    }, [tc, isSaved]);
    //don't add the function to dependency

    //COMPARISON STUFF ^^

    useEffect(() => {
        if (tc) {
            if (tc){
                setDocumentRating(tcRatingToLetter(tc.tcRating));
                setDocName(tc.name);
                setContractType(tc.contractType);
                if (tc.product){
                    setProduct(tc.product);
                } else {
                    setProduct("No Product Specified");
                }

                if (tc.company){
                    setCompany(tc.company);
                } else {
                    setCompany("No Company Specified");
                }

                if (tc.hasOwnProperty("userRating")){
                    setGradeDoc(userRatingToLetter(tc.userRating));
                } else {
                    setGradeDoc(null);
                }
                
                if (tc.hasOwnProperty("active")){
                    console.log("settingactive");
                    setActive(tc.active);
                } else {
                    console.log("yoooooooo");
                }

                if (tc.dateSigned){
                    const signDate = new Date(tc.dateSigned);

                    const y = signDate.getFullYear();
                    const m = (signDate.getMonth()+1) <= 9 ? "0"+(signDate.getMonth()+1) : signDate.getMonth()+1;
                    const d = signDate.getDate() <= 9 ? "0"+signDate.getDate() : signDate.getDate();

                    setDate(y + "-" + m + "-" + d);
                    setIsSigned(true);
                } else {
                    const td = new Date();
                    const y = td.getFullYear();
                    const m = (td.getMonth()+1) <= 9 ? "0"+(td.getMonth()+1) : td.getMonth()+1;
                    const d = td.getDate() <= 9 ? "0"+td.getDate() : td.getDate();
                    setDate(y + "-" + m + "-" + d);
                    
                    setIsSigned(false);
                }
                if (tc.expiryDate){
                    const expiryDate = new Date(tc.expiryDate);
                    const y = expiryDate.getFullYear();
                    const m = (expiryDate.getMonth()+1) <= 9 ? "0"+(expiryDate.getMonth()+1) : expiryDate.getMonth()+1;
                    const d = expiryDate.getDate() <= 9 ? "0"+expiryDate.getDate() : expiryDate.getDate();
                    setExpDate(y + "-" + m + "-" + d);
                    setIsExpirySet(true);
                } else {
                    setExpDate("");
                    setIsExpirySet(false);
                }
            }
        }
    }, [tc]);

    useEffect(() => {
        if (analysis){
            setContent(analysis.content);
            // console.log(content);
        } else {
            setContent("No associated analysis");
        }
    }, [analysis])

    useEffect(() => {
        // console.log(gtc)
        // console.log(comp)
        // console.log(ucomp)
        if (gtc){
            setUserRating(userRatingToLetter(gtc.userRating));
        } else {
            setUserRating(" ");
        }

        if (comp){
            setCompanyRating(compRatingToLetter(comp.companyRating));
            // console.log("company rating changed");
        } else {
            setCompanyRating(" ");
        }
        if (ucomp){
            setGradeComp(userRatingToLetter(ucomp.companyRating));
        } else {
            setGradeComp(null);
        }
    }, [gtc, comp, ucomp]);

    const handleSign = ()=> {
        if (date === "") {
            console.log("No date");
        } else {
            let tosend = {};
            tosend.dateSigned = new Date(date + "T00:00");
            axios
            .put(`/api/v1/tcs/update/${params.tcid}`, tosend)
            .then((response) => {
                //TODO
                if (response.data.usertc){
                    dispatch({ type: TC_UTC_UPDATED, payload: response.data.usertc });
                }
            })
            .catch(function (error) {
                if (error.response) {
                    //request made and server rejected it
                    console.log(`${error.response.status}: ${error.response.data.message}`);
                  } else if (error.request){
                    //request made but no response received
                    console.log("No response from server");
                  } else {
                    //some other problem while setting up the request
                    console.log("Error setting up request");
                  }
            });
        }
    }

    const handleSetExpiry = ()=> {
        if (expDate === "") {
            console.log("No expiry date");
        } else {
            let tosend = {};
            tosend.expiryDate = new Date(expDate + "T00:00");
            axios
            .put(`/api/v1/tcs/update/${params.tcid}`, tosend)
            .then((response) => {
                //TODO
                if (response.data.usertc){
                    dispatch({ type: TC_UTC_UPDATED, payload: response.data.usertc });
                }
            })
            .catch(function (error) {
                if (error.response) {
                    //request made and server rejected it
                    console.log(`${error.response.status}: ${error.response.data.message}`);
                  } else if (error.request){
                    //request made but no response received
                    console.log("No response from server");
                  } else {
                    //some other problem while setting up the request
                    console.log("Error setting up request");
                  }
            });
        }
    }

    const submitCompRating = () => {
        if (gradeComp === null) {
            setGradeComp(null);
        } else {
            if (isAuth && tc.userCompany){
                let nf = {};
                nf.newCompanyRating = compLetterToRating(gradeComp);
                console.log(nf);
                axios
                .put(`/api/v1/tcs/rate/company/${tc.userCompany}`, nf)
                .then((response) => {
                    //TODO
                    if (response.data.comp){
                        dispatch({ type: TC_CRATE_UPDATED, payload: response.data.comp });
                    }
                    if (response.data.ucomp){
                        dispatch({ type: TC_UCRATE_UPDATED, payload: response.data.ucomp});
                    }
                })
                .catch(function (error) {
                    if (error.response) {
                        //request made and server rejected it
                        console.log(`${error.response.status}: ${error.response.data.message}`);
                      } else if (error.request){
                        //request made but no response received
                        console.log("No response from server");
                      } else {
                        //some other problem while setting up the request
                        console.log("Error setting up request");
                      }
                });
            } else {
                console.log("sign in first");
            }
            // setGradeDoc(grade);
            // setUserRating(grade);
        }
    }

    const submitUserRating = () => {
        if (gradeDoc === null) {
            setGradeDoc(null);
        } else {
            if (isAuth){
                let nf = {};
                nf.newUserRating = userLetterToRating(gradeDoc);
                axios
                .put(`/api/v1/tcs/rate/tc/${params.tcid}`, nf)
                .then((response) => {
                    //TODO
                    if (response.data.gtc){
                        dispatch({ type: TC_URATE_UPDATED, payload: response.data.gtc });
                    }
                })
                .catch(function (error) {
                    if (error.response) {
                        //request made and server rejected it
                        console.log(`${error.response.status}: ${error.response.data.message}`);
                      } else if (error.request){
                        //request made but no response received
                        console.log("No response from server");
                      } else {
                        //some other problem while setting up the request
                        console.log("Error setting up request");
                      }
                });
            } else {
                console.log("sign in first");
            }
            // setGradeDoc(grade);
            // setUserRating(grade);
        }
    }
    const closePopUpDoc = () => {
        if (gradeDoc === null) {
        } else {
            setIsOpenDoc(false);
            // setUserRating(gradeDoc);
        }
    }
    const closePopUpComp = () => {
        if (gradeComp === null) {
        } else {
            setIsOpenComp(false);
            // setCompanyRating(gradeComp);
        }
    }

    const handleDelete = async () => {
        // if (!isAuth){
        //     alert("Please Login first");
        //     return;
        // }

        // if (unsaveds.hasOwnProperty(params.tcid)){
        //     alert("An unsaved document cannot be deleted");
        //     return;
        // }

        try {
            let response = await axios({
                method: 'delete',
                url: `api/v1/tcs/delete/${params.tcid}`,
                baseURL: '/',
            });

            if (!response.data.success){
                alert("failed to delete document");
                return;
            }

            dispatch({ type: TC_INVALIDATED });

            navigate('/mydocuments');

        } catch (error) {
            alert("error occured");
            return;
        }
    }

    const saveContractDetails = async () => {
         // router.route("/save/:id/:token").put(isAuthenticatedUser, saveTC);
        // axios
        //     .put(`/save/${tcid}/`)
        console.log(docName);
        if (!isAuth){
            alert("Please Login first");
            return;
        }

        if (!popupName) {
            alert("Please enter the document's name.");
            return;
        }
        if (!popupType) {
            alert("Please enter the contract type.");
            return;
        }
        if (!popupProduct) {
            alert("Please enter the product's name.");
            return;
        }
        if (!popupCompany) {
            alert("Please enter the company's name.");
            return;
        }
        
        // setDocName(popupName);
        // setContractType(popupType);
        // setProduct(popupProduct);
        // setCompany(popupCompany);
        let tosend = {};
        tosend.name = popupName;
        tosend.contractType = popupType;
        tosend.product = popupProduct;
        tosend.company = popupCompany;
        tosend.active = active;

        try {
            let response;
            if (unsaveds.hasOwnProperty(params.tcid)){
                response = await axios({
                    method: 'put',
                    url: `api/v1/tcs/save/${params.tcid}/${unsaveds[params.tcid]}`,
                    baseURL: '/',
                    data: tosend
                });

                if (!response.data.success){
                    alert("failed to save document");
                    return;
                }

                dispatch({type: TC_UNSAVED_DELETE, payload: { tcid: params.tcid }});

            } else {
                response = await axios({
                    method: 'put',
                    url: `api/v1/tcs/update/${params.tcid}`,
                    baseURL:'/',
                    data: tosend
                })

                if (!response.data.success){
                    alert("failed to update document");
                    return;
                }
            }

            const loadData = await axios({
                method: 'get',
                url: `api/v1/tcs/full/${params.tcid}`,
                baseURL: '/'
            });

            if (!loadData.data.success){
                alert("failed to retrieve updated document");
                return;
            }

            dispatch({ type: TC_UPDATED , payload: loadData.data.fullData });

        } catch (error) {
            alert("error occured");
            return;
        }

        setIsOpenSave(false);
        console.log("Saved document");
    }
    
    function localStorageReset() {
        localStorage.clear();
        // localStorage.removeItem("contractType");
        // localStorage.removeItem("product");
        // localStorage.removeItem("company");
    }

    return (
        <div className="documentSide">
            <div className="documentHeading"> 
                <div className="contractInfo">
                    <Link to={"/upload"} className="linkItem" key={"uploadAnotherBtn"}>
                        <h2 className="documentSideBtn" onClick={localStorageReset}><FaIcons.FaArrowLeft/> Analyze new contract</h2>
                    </Link>
                    <h2 id="docName">Name: {docName}</h2>
                    <h2 id="docType">Contract type: {contractType}</h2>
                    <h2 id="docProduct">Product: {product}</h2>
                    <h2 id="docCompany">Company: {company}</h2>
                    {isSaved && <>                        
                        <div>
                            <h2>{isSigned ? "Signed On:" : "Sign Now:"} <input className="" type="date" value={date} onChange={e=> setDate(e.target.value)}/> </h2>
                            <h2 className="documentSideBtn" onClick={handleSign}>Sign</h2>
                        </div>

                        <div>
                            <h2>{isExpirySet ? "Expires On:" : "Set Expiry:"} <input className="" type="date" value={expDate} onChange={e=> setExpDate(e.target.value)}/> </h2>
                            <h2 className="documentSideBtn" onClick={handleSetExpiry}>Set Expiry Date</h2>
                        </div>
                    </>}
                </div>
                <div className="rating">
                    <Popup className="ratingKeyPopUp" contentStyle={{width: "40%"}} on="click"
                        open={isOpenSave} onOpen={() => setIsOpenSave(!isOpenSave)}
                        trigger= {<h2 className="documentSideBtn" id="saveBtn">{isSaved ? "Edit Document" : "Save to account"}</h2>} 
                        modal nested>
                        {
                            close => (
                                <div className="editContractPopup">
                                    <div className="saveChangeInfo">
                                        <label><span>Document Name:</span><input id="nameInput" type="text" defaultValue={docName} onChange={(e)=> popupName = e.target.value}/></label>
                                        <label><span>Contract Type:</span><input id="typeInput" type="text" defaultValue={contractType} onChange={(e)=> popupType = e.target.value}/></label>
                                        <label><span>Product:</span><input id="productInput" type="text" defaultValue={product} onChange={(e)=> popupProduct = e.target.value}/></label>
                                        <label><span>Company:</span><input id="companyInput" type="text" defaultValue={company} onChange={(e)=> popupCompany = e.target.value}/></label>
                                        <label><span>Active:</span><input type="checkbox" name="active" checked={active} onChange={(e) => setActive(!active)} /></label>
                                        <h2 className="saveDetails" onClick={()=>saveContractDetails(false)}>Save</h2>
                                    </div>
                                </div>
                            )
                        }
                    </Popup>
                    <h2><span className="ratingResults">Document Rating </span><span className={documentRating[0] + " grade"}>{documentRating}</span></h2>
                    { isSaved && <>
                        <h2><span className="ratingResults">Company Rating </span><span className={companyRating[0] + " grade"}>{companyRating}</span></h2>
                        <Popup contentStyle={{width: "60%"}} on="click"
                            open={isOpenComp} onOpen={() => setIsOpenComp(!isOpenComp)}
                            trigger= {<h2 className="documentSideBtn" id="rateCompany">Rate the company</h2>} 
                            modal nested>
                            {
                                close => (
                                    <div className='userRatingModal'>
                                        <h2 key="chooseUserRatingHeading">This contract is</h2>
                                        <div className="chooseUserRating">
                                            {grades.map ((grades) => {
                                                const grade = grades.grade;
                                                const desc = grades.desc;
                                                return (
                                                    <div className="ratingPair" key={"ratingPair" + grade} onClick={()=>setGradeComp(grade)}>
                                                        <h3 className={gradeComp === grade ? "userRatingGrade " + grade + " active": "userRatingGrade " + grade} key={"userRatingGrade"+grade}>{grade}</h3>
                                                        <h4 className={gradeComp === grade ? "ratingDesc active" : "ratingDesc"} key={"userRatingDesc"+grade}>{desc}</h4>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                        <h2 className="submitUserRatingBtn" onClick={()=>{
                                            submitCompRating();
                                            closePopUpComp(false);
                                        }}>Submit</h2>
                                    </div>
                                )
                            }
                        </Popup>
                        <h2><span className="ratingResults">User Rating </span><span className={userRating[0] + " grade"}>{userRating}</span></h2>
                        <Popup contentStyle={{width: "60%"}} on="click"
                            open={isOpenDoc} onOpen={() => setIsOpenDoc(!isOpenDoc)}
                            trigger= {<h2 className="documentSideBtn" id="rateDoc">Rate the document</h2>} 
                            modal nested>
                            {
                                close => (
                                    <div className='userRatingModal'>
                                        <h2 key="chooseUserRatingHeading">This contract is</h2>
                                        <div className="chooseUserRating">
                                            {grades.map ((grades) => {
                                                const grade = grades.grade;
                                                const desc = grades.desc;
                                                return (
                                                    <div className="ratingPair" key={"ratingPair" + grade} onClick={()=>setGradeDoc(grade)}>
                                                        <h3 className={gradeDoc === grade ? "userRatingGrade " + grade + " active": "userRatingGrade " + grade} key={"userRatingGrade"+grade}>{grade}</h3>
                                                        <h4 className={gradeDoc === grade ? "ratingDesc active" : "ratingDesc"} key={"userRatingDesc"+grade}>{desc}</h4>
                                                    </div>
                                                )
                                            })}
                                        </div>
                                        <h2 className="submitUserRatingBtn" onClick={()=>{
                                            submitUserRating();
                                            closePopUpDoc(false);
                                        }}>Submit</h2>
                                    </div>
                                )
                            }
                        </Popup>
                        <Popup className="ratingKeyPopUp" contentStyle={{width: "60%"}} on="click"
                            open={isOpenKey} onOpen={() => setIsOpenKey(!isOpenKey)}
                            trigger= {<h2 className="ratingKeyLine" id="openKey">See Rating Key <FaIcons.FaBars className="openRating"/></h2>} 
                            modal nested>
                            {
                                close => (
                                    <div className="ratingKey">T&C Rating scale is based on a score calculated from the intensity and prevalence of red flags.<br/>
                                        <ul>
                                            <li>A: 0-15 (Safe)</li><br/>
                                            <li>B: 16-40</li><br/>
                                            <li>C: 41-70</li><br/>
                                            <li>D: 71-90</li><br/>
                                            <li>F: 90-100 (Unsafe)</li><br/>
                                        </ul>
                                        User Rating scale is the average rating by users on how safe this contract is.<br/>
                                        <ul>
                                            <li>A: Safe</li><br/>
                                            <li>B: Relatively safe</li><br/>
                                            <li>C: Neither safe nor unsafe</li><br/>
                                            <li>D: Unsafe</li><br/>
                                            <li>F: Very unsafe</li>
                                        </ul>
                                    </div>
                                )
                            }
                        </Popup>
                        <Popup open={isOpenDelete} on="click" onOpen={() => setIsOpenDelete(!isOpenDelete)}
                            trigger={<h2 className="documentSideBtn" id="deleteBtn">Delete this Document</h2>}
                            modal nested>
                            {close => (
                                <div className="modal">
                                <div className="header">Are you sure you want to delete this document?</div>
                                <div className="actions">
                                    <button
                                    className="yes-button"
                                    onClick={() => {
                                        handleDelete();
                                        setIsOpenDelete(false);
                                    }}
                                    >
                                    Yes
                                    </button>
                                    <button className="no-button" onClick={()=>setIsOpenDelete(false)}>
                                    No
                                    </button>
                                </div>
                                </div>
                            )}
                        </Popup>
                    </>}
                </div>
            </div>
            <Clarification
                setDisplayClarificationPopup={setDisplayClarificationPopup}
                setClarificationContent={setClarificationContent}
                setClarificationText={setClarificationText}
                textBody={GetText(content, analysis)}
            />
            {/* {GetText(content, analysis)}
            <ClarificationPopup 
                open={displayClarificationPopup}
                highlightedText={clarificationText}
                clarification={clarificationContent}
                onClose={() => setDisplayClarificationPopup(false)}
            /> */}
        </div>
    );
};

// let refs = [];
const GetText = (txt, analysis) => {
    const { c_l_red_flags } = useSelector((state) => state.compare);
    let text = txt;
    if (analysis === null) {
        //console.log("Analysis is null");
        return React.createElement("div", {className:"documentText"}, [<span>{text}</span>]);
    }
    const handleClick = (ref) => {    
        if (ref) {
            console.log(ref);
            ref.scrollIntoView({ behavior: 'smooth' });
        }
    }    

    let redFlags = [];
    if (analysis) {
        //console.log(analysis.redflags);
        redFlags = analysis.redflags;
    }

    let outOfPlace = [];
    if (analysis){
        outOfPlace = analysis.outofplace;
    }

    let compare = [];
    if (c_l_red_flags) {
        //console.log(c_l_red_flags);
        compare = c_l_red_flags;
    }

    redFlags.sort((a,b) => {
        if (a.locL < b.locL) return -1;
        if (a.locL > b.locL) return 1;
        return 0;
    })
    outOfPlace.sort((a,b) => {
        if (a.locL < b.locL) return -1;
        if (a.locL > b.locL) return 1;
        return 0;
    })
    compare.sort((a,b) => {
        if (a.locL < b.locL) return -1;
        if (a.locL > b.locL) return 1;
        return 0;
    })

    const childNodes = [];
    const highlightActive = (getTab() === tabInfo[0].id || getTab() === tabInfo[1].id || getTab() === tabInfo[2].id);

    const index = [];
    if (analysis === null) {
        return React.createElement("div", {className:"documentText"}, [<span>{text}</span>]);
    }

    let ind = 0;

    if(getTab() === tabInfo[0].id || getTab() === tabInfo[1].id) {
        // index = rf
        let o = 0;
        let r = 0;
        while (o < outOfPlace.length || r < redFlags.length) {
            if (o >= outOfPlace.length) {
                index.push([redFlags[r].locL, "rf", redFlags[r]]);
                r++;
            } else if (r >= redFlags.length) {
                index.push([outOfPlace[o].locL, "oop", outOfPlace[o]]);
                o++;
            } else if (redFlags[r].locL <= outOfPlace[o].locL) {
                index.push([redFlags[r].locL, "rf", redFlags[r]]);
                ind = redFlags[r].locR;
                r++;
            } else if (outOfPlace[o].locL > ind && outOfPlace[o].locR < redFlags[r].locL) {
                index.push([outOfPlace[o].locL, "oop", outOfPlace[o]]);
                ind = outOfPlace[o].locR;
                o++;
            } else {
                o++;
            }
        }
    }

    if(getTab() === tabInfo[2].id) {
        // index = oop
        let o = 0;
        let r = 0;
        while (o < outOfPlace.length || r < redFlags.length) {
            if (r >= redFlags.length) {
                index.push([outOfPlace[o].locL, "oop", outOfPlace[o]]);
                o++;
            }else if (o >= outOfPlace.length) {
                index.push([redFlags[r].locL, "rf", redFlags[r]]);
                r++;
            } else if (outOfPlace[o].locL <= redFlags[r].locL) {
                index.push([outOfPlace[o].locL, "oop", outOfPlace[o]]);
                ind = outOfPlace[o].locR;
                o++;
            } else if (redFlags[r].locL > ind && redFlags[r].locR < outOfPlace[o].locL) {
                index.push([redFlags[r].locL, "rf", redFlags[r]]);
                ind = redFlags[r].locR;
                r++;
            } else {
                r++;
            }
        }
    }

    if (getTab() === tabInfo[3].id) {
        for (let i = 0; i < compare.length; i++) {
            index.push([compare[i].locL, "c", compare[i]]);
        }
    }

    index.sort((a,b) => {
        if (a[0] < b[0]) return -1;
        if (a[0] > b[0]) return 1;
        return 0;
    })

    let currIndex = 0;

    const getClass = (type, index, i) => {
        if (type === "rf") {
            return highlightActive ? (index[i][2].severity === undefined ?  "mediumRF" : index[i][2].severity + "RF") : "";
        }
        if (type === "c") {
            return highlightActive ? (index[i][2].severity === undefined ?  "mediumRF" : index[i][2].severity + "RF") : "mediumRF";
        }
        if (type === "oop") {
            return highlightActive ? "outOfPlaceOutput" : "";
        }
        if (type === "rfoop") {
            if (getTab() === tabInfo[0].id && getTab() === tabInfo[1].id) {
                return index[i][2].severity + "RF";
            } else if (getTab() === tabInfo[2].id) {
                return "outOfPlaceOutput";
            }
        }
        if (type === "rfcoop") {
            if (getTab() === tabInfo[0].id && getTab() === tabInfo[1].id) {
                return index[i][2].severity + "RF";
            } else if (getTab() === tabInfo[2].id) {
                return "outOfPlaceOutput";
            } else {
                return "mediumRF";
            }
        }
        return "";
    }

    for (let i = 0; i < index.length; i++) {
        if (currIndex > index[i][0] || index[i][0] < 0) {
            continue;
        }
        if (currIndex < index[i][0]) {
            childNodes.push(<span key={"sn"+i}>
            {text.substring(currIndex, index[i][0])}</span>);
            currIndex = index[i][0];
        }

        childNodes.push(<span key={i} className={getClass(index[i][1], index, i)}
            ref={(e) => {index[i][2].ref = e}} onClick={()=>handleClick(index[i][2].oref)}>
            {text.substring(currIndex, index[i][2].locR)}</span>);
        currIndex = index[i][2].locR;
    }

    if (currIndex < text.length) {
        childNodes.push(<span>{text.substring(currIndex)}</span>);
    }
    return React.createElement("div", {className:"documentText"}, childNodes);
}

export default DocumentSide;